'use client';

import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'material-icons/iconfont/material-icons.css';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { NextAppDirEmotionCacheProvider } from 'tss-react/next/appDir';

import { GlobalStyles } from 'tss-react';

import { or2Theme } from './theme';

export function ThemeRegistry({ children }: { children: React.ReactNode }) {
  return (
    <NextAppDirEmotionCacheProvider options={{ key: 'mui' }}>
      <ThemeProvider theme={or2Theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <GlobalStyles
          styles={`
            input[type='search']::-webkit-search-decoration,
            input[type='search']::-webkit-search-cancel-button,
            input[type='search']::-webkit-search-results-button,
            input[type='search']::-webkit-search-results-decoration {
              -webkit-appearance: none;
            }

            .tiptap p.is-editor-empty:first-child::before {
              color: ${or2Theme.palette.text.disabled};
              content: attr(data-placeholder);
              float: left;
              height: 0;
              pointer-events: none;
            }

            /* Ensure notistack snackbars use our theme radius */
            .notistack-MuiContent {
              border-radius: ${or2Theme.shape.borderRadius}px !important;
            }
          `}
        />
        {children}
      </ThemeProvider>
    </NextAppDirEmotionCacheProvider>
  );
}
